import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface ISuccessStories {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  title?: string;
  title_text_color?: string;
  subtitle?: string;
  subtitle_text_color?: string;
  indicator_color?: string;
  left_navigation_icon?: string;
  left_navigation_icon_alt?: string;
  right_navigation_icon?: string;
  right_navigation_icon_alt?: string;
  background_color?: string;
  variant?: string;
  metadata?: any[];
  status?: boolean;
}

export async function createSuccessStories(payload: Partial<ISuccessStories>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.SUCCESS_STORIES.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateSuccessStories(id: number, payload: Partial<ISuccessStories>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.SUCCESS_STORIES.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

